@for (event of eventList; track $index; let last = $last){
    
    <app-event-summary class="cursor-pointer" [event]="event"  [routerLink]="'/events/' + event.eventLink" (bookingButtonClicked)="this.navigate(event)" />
    @if (!last){
        <p-divider type="solid" styleClass="border-2" />  
    }
}